import * as React from 'react';
import { observer } from 'mobx-react';
import { CategoryIcon, CategoryType, getMasterCategoryList } from 'owa-categories';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');

export interface CategoryPillProps {
    categoryName: string;
    isSelected: boolean;
    categoryList?: CategoryType[];
}

@observer
export default class CategoryPill extends React.Component<CategoryPillProps, {}> {
    private pillDiv: HTMLElement;

    componentDidUpdate() {
        if (this.props.isSelected) {
            this.pillDiv.focus();
        }
    }

    render() {
        const categoryName = this.props.categoryName;

        return (
            <div
                ref={ref => (this.pillDiv = ref)}
                tabIndex={-1}
                className={searchBoxPillWellStyles.categoryPill}>
                <CategoryIcon
                    categoryName={categoryName}
                    iconClassName={searchBoxPillWellStyles.categoryIcon}
                    categoryList={
                        this.props.categoryList ? this.props.categoryList : getMasterCategoryList()
                    }
                />
                <div className={searchBoxPillWellStyles.categoryPillNameText} title={categoryName}>
                    {categoryName}
                </div>
            </div>
        );
    }
}
